import { getParam } from "../utils/get-param";

export const formBuilderProps = {
  from: getParam("formBuilderFrom") || undefined,
  value: getParam("formBuilderValue") || undefined,
};
